import { useApiGet } from "@/hooks/useApi";
import { getMostWatchedCourses } from "../api";

export function useGetMostWatchedCourses({ options } = {}) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		// Was ["courses", "list", "most-liked"] — identical to
		// useGetMostLikedCourses, so the two shared one cache entry.
		key: ["courses", "list", "most-watched"],
		fn: getMostWatchedCourses,
		options,
	});

	const { courses } = data || { courses: [] };

	return { data: courses, isPending, isSuccess, isError, error };
}
